import { Box, TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';

import { ReactComponent as EditIcon } from '../../assets/images/highlight.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/DeleteIcon.svg';

import TooltipTableCell from '../../components/formlib/TooltipTableCell';
import ActionToolTip from '../../components/formlib/ActionToolTip';
import { getRoleName } from '../../utils/nameUtils';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { UnifiedMemberType } from './IfspMainScreen';

interface IfspTable {
  data: UnifiedMemberType;
  onDelete?: (id: string) => void;
  onEdit?: (data: UnifiedMemberType) => void;
  dateRequired?: boolean;
  isIfspScreenLocked?: boolean;
  isIntakeLocked?: boolean;
}

const IfspMembersTableRow: FC<IfspTable> = ({
  data,
  onDelete,
  onEdit,
  dateRequired,
  isIfspScreenLocked,
  isIntakeLocked,
}) => {
  const { lookups } = useContext(LookUpContext);
  const handleDeleteClick = () => {
    if (onDelete && !isIfspScreenLocked && !isIntakeLocked) {
      onDelete(data.id || '');
    }
  };
  const handleEdit = () => {
    if (onEdit && !isIfspScreenLocked && !isIntakeLocked) {
      onEdit(data);
    }
  };

  const getGuardianType = (gaurdianType: string): string => {
    return (
      lookups?.guardianType?.find(
        (g) => g.code.toUpperCase() === gaurdianType.toUpperCase(),
      )?.description || '-'
    );
  };

  const getDateLabel = (date: string | null | undefined): string => {
    if (
      (date === '' || date === null) &&
      (data.memberType === 'team' || data.memberType === 'other')
    ) {
      return '-';
    } else if (date !== undefined && date !== null && date !== '') {
      return date;
    } else {
      return 'Not Applicable';
    }
  };

  const role =
    data.memberType === 'team'
      ? getRoleName(data.role || '')
      : getGuardianType(data.role || '');
  return (
    <TableRow
      className="tableRowcss"
      sx={{
        cursor: 'pointer',
        alignContent: 'flex-start',
        '&:nth-of-type(odd)': {
          backgroundColor: '#ECF9F8',
        },
      }}
    >
      <TableCell>
        <TooltipTableCell
          value={data.name ? data.name : '-'}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            data.discipline
              ? lookups?.employeeDiscipline.find(
                  (d) => d.code === data.discipline,
                )?.description || '-'
              : '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={role}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={data.email ? data.email : '-'}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={data.phoneNumber ? data.phoneNumber : '-'}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      {!dateRequired && (
        <TableCell>
          <MediumTypography label={getDateLabel(data.startDate as string)} />
        </TableCell>
      )}
      {!dateRequired && (
        <TableCell>
          <MediumTypography label={getDateLabel(data.endDate as string)} />
        </TableCell>
      )}
      <TableCell>
        <Box component="div" className="flex__">
          {data.startDate !== undefined &&
            data.startDate !== '' &&
            data.startDate !== null && (
              <Box
                component="div"
                className="pr-sm pt-xs"
                sx={{
                  cursor:
                    !isIfspScreenLocked && !isIntakeLocked
                      ? 'pointer'
                      : 'not-allowed',
                }}
              >
                <ActionToolTip labelId="BlockTime.edit" defaultLabel="Edit">
                  <EditIcon onClick={handleEdit} />
                </ActionToolTip>
              </Box>
            )}
          {dateRequired && data.discipline && data.role !== 'parent' && (
            <Box
              component="div"
              className="pr-sm pt-xs"
              sx={{
                cursor:
                  !isIfspScreenLocked && !isIntakeLocked
                    ? 'pointer'
                    : 'not-allowed',
              }}
            >
              <ActionToolTip labelId="BlockTime.edit" defaultLabel="Edit">
                <EditIcon onClick={handleEdit} />
              </ActionToolTip>
            </Box>
          )}
          <Box
            component="div"
            className="pt-xs"
            sx={{
              cursor:
                !isIfspScreenLocked && !isIntakeLocked
                  ? 'pointer'
                  : 'not-allowed',
            }}
          >
            <ActionToolTip labelId="BlockTime.delete" defaultLabel="Delete">
              <DeleteIcon onClick={handleDeleteClick} />
            </ActionToolTip>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default IfspMembersTableRow;
